<template>
  <el-form :model="model" :disabled="!!disabled">
    <el-row>
      <el-col :span="3">
        <form-item
          prop="frequency"
          :label="$t('RecurrenceSettings_Field_Frequency')"
        >
          <enum-select
            v-model="model.frequency"
            :placeholder="$t('RecurrenceSettings_Field_Frequency')"
            :options="frequencyLabels"
            :disabled-options="disabledOptions"
          />
        </form-item>
      </el-col>
      <el-col
        :span="3"
        :class="{ weekly: model.frequency === 'weekly' }"
        v-if="model.frequency !== 'daily' && model.frequency !== 'hourly'"
      >
        <form-item prop="day" :label="$t('RecurrenceSettings_Field_Day')">
          <template v-if="model.frequency === 'monthly'">
            <enum-select v-model="day" :options="FrequencyDayLabel" />
          </template>
          <template v-else>
            <el-button
              @click="selectDay(val)"
              class="day"
              :class="{ selected: isSelected(val) }"
              v-for="(label, val) in DayOfWeekLabel"
              :key="val"
            >
              {{ $t(label) }}
            </el-button>
          </template>
        </form-item>
      </el-col>
      <el-col :span="3" v-if="model.frequency === 'hourly'">
        <form-item :label="$t('RecurrenceSettings_Field_Minutes')">
          <el-input-number
            controls-position="right"
            v-model="model.minutes"
            :min="0"
            :max="59"
          />
        </form-item>
      </el-col>
      <el-col :span="3" v-if="model.frequency === 'monthly' && !day">
        <form-item label=" ">
          <el-input-number
            controls-position="right"
            v-model="dayNumber"
            :min="1"
            :max="31"
          />
        </form-item>
      </el-col>
      <el-col :span="3" v-if="model.frequency !== 'hourly'">
        <form-item prop="time" :label="$t('RecurrenceSettings_Field_Time')">
          <el-time-picker
            v-model="model.time"
            format="HH:mm"
            value-format="HH:mm"
            :clearable="false"
            data-qa="schedule-time-input"
          />
        </form-item>
      </el-col>
      <el-col :span="3" v-if="model.frequency !== 'hourly'">
        <form-item :label="$t('RecurrenceSettings_Field_Timezone')">
          <span class="timezone">{{ timezone }}</span>
        </form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import {
  FrequencyTypeLabel,
  FrequencyTypeLabelCampaignReport,
  FrequencyDayLabel,
  DayOfWeekLabel
} from '@/modules/automations/enum/RecurrenceEnum'
import EnumSelect from '@/common/components/form/EnumSelect'
import FormItem from '@/common/components/form/FormItem'

export default {
  name: 'RecurrenceSettings',
  components: { FormItem, EnumSelect },
  props: {
    model: {
      type: Object,
      required: true,
      default: () => {}
    },
    timezone: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    delta: {
      type: Number,
      required: false,
      default: 0
    },
    isCampaignReport: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted() {
    if (!this.delta && this.model.frequency === 'hourly') {
      this.model.frequency = 'daily'
    }
    if (Object.keys(this.FrequencyDayLabel).includes(this.model.day)) {
      this.day = this.model.day
    } else if (!isNaN(this.model.day)) {
      this.dayNumber = this.model.day
    }

    this.frequencyLabels = this.isCampaignReport
      ? this.FrequencyTypeLabelCampaignReport
      : this.FrequencyTypeLabel
  },
  data() {
    return {
      day: '',
      dayNumber: null,
      frequencyLabels: {},
      defaultDayNumber: 1,
      FrequencyTypeLabel,
      FrequencyTypeLabelCampaignReport,
      FrequencyDayLabel,
      DayOfWeekLabel
    }
  },
  computed: {
    disabledOptions() {
      return []
      // Hourly is available only for delta reports
      // return !this.delta ? ['hourly'] : []
    }
  },
  methods: {
    selectDay(day) {
      const index = this.model.day.indexOf(day)
      if (index > -1) {
        this.model.day.splice(index, 1)
      } else {
        this.model.day.push(day)
      }
      this.$forceUpdate()
    },
    isSelected(day) {
      return this.model.day.includes(day)
    }
  },
  watch: {
    day() {
      if (this.day === '') {
        this.dayNumber = this.defaultDayNumber
        this.model.day = this.dayNumber
      } else {
        this.model.day = this.day
      }
    },
    dayNumber(val) {
      this.model.day = val
    },
    'model.frequency': {
      deep: true,
      handler(frequency) {
        if (frequency === 'hourly') {
          if (
            !this.model.hasOwnProperty('minutes') ||
            this.model.minutes === null
          ) {
            this.model.minutes = new Date().getMinutes()
          }
        } else if (frequency === 'weekly') {
          this.model.day = []
        } else if (frequency === 'monthly') {
          this.dayNumber = this.defaultDayNumber
          this.model.day = this.dayNumber
        } else {
          this.model.day = null
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.timezone {
  line-height: 40px;
}
.weekly {
  width: 430px;
}
.day {
  padding: 12px 8px;
  width: 50px;
  color: #606266;
  font-weight: inherit;

  &.selected {
    background: #e6f3fb;
    border: 1px solid #1d87c8;

    &:hover {
      color: #606266;
    }
  }
}
>>> .el-input-number {
  width: inherit;
}
>>> .el-input-number__decrease,
>>> .el-input-number__increase {
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/automations/components/RecurrenceSettings.vue